import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { ClearLot, SetLot, SetReceiptFields, StockEntryStateModel } from './stock-entry.actions';

@State<StockEntryStateModel>({
  name: 'stockEntry',
  defaults: {
    lotId: null,
    lotNumero: null,
    lotSacaNumero: null,
    lotStatus: null,
    lotQuantityChecked: null,
    lotQuantityToCheck: null,
    lotTotalQuantity: null,
    lotDate: null,
    receiptInvoiceKey: null,
    receiptTradeId: null,
    receiptImei: null,
  },
})
@Injectable()
export class StockEntryState {
  @Selector()
  static lot(state: StockEntryStateModel): StockEntryStateModel {
    return state;
  }

  @Selector()
  static lotNumero(state: StockEntryStateModel): number | null {
    return state.lotNumero;
  }

  @Action(SetLot)
  setLot({ patchState }: StateContext<StockEntryStateModel>, { payload }: SetLot) {
    patchState({
      lotId: payload.id,
      lotNumero: payload.numero,
      lotSacaNumero: payload.sacaNumero ?? null,
      lotStatus: payload.status,
      lotQuantityChecked: payload.quantityChecked ?? null,
      lotQuantityToCheck: payload.quantityToCheck ?? null,
      lotTotalQuantity: payload.totalQuantity ?? null,
      lotDate: payload.lotDate ?? null,
    });
  }

  @Action(SetReceiptFields)
  setReceiptFields({ patchState }: StateContext<StockEntryStateModel>, { payload }: SetReceiptFields) {
    patchState({
      receiptInvoiceKey: payload.invoiceKey,
      receiptTradeId: payload.tradeId,
      receiptImei: payload.imei,
    });
  }

  @Action(ClearLot)
  clearLot({ patchState }: StateContext<StockEntryStateModel>) {
    patchState({
      lotId: null,
      lotNumero: null,
      lotSacaNumero: null,
      lotStatus: null,
      lotQuantityChecked: null,
      lotQuantityToCheck: null,
      lotTotalQuantity: null,
      lotDate: null,
      receiptInvoiceKey: null,
      receiptTradeId: null,
      receiptImei: null,
    });
  }
}
